import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { User } from "../../utils";
import { Company, Employee } from "../../types";
import LandingPagesList from "./LandingPagesList";
import WebArtifactsPanel from "./WebArtifactsPanel";
import InfoAccordion from "../../components/InfoAccordion";
import TrackingDomainsPanel from "../sequences/dialogs/TrackingDomainsPanel";

interface LandingPagesManagerProps {
  currentUser: User;
  getToken: () => Promise<string>;
  eventListener: (event: any) => void;
  companyId: string;
  company: Company;
  employees: Employee[];
  currentPlan: string;
}

const LandingPagesManager: React.FC<LandingPagesManagerProps> = ({
  currentUser,
  getToken,
  eventListener,
  companyId,
  company,
  employees,
  currentPlan,
}) => {
  const [currentTab, setCurrentTab] = useState("pages");

  return (
    <Box>
      <Box>
        <InfoAccordion title="Landing Pages Overview" sx={{ mt: 2 }}>
          <Box sx={{ mt: 1 }}>
            Create single web pages for marketing campaigns, lead capture, and promotional content.
            <Box component="ul" sx={{ mt: 1, pl: 2 }}>
              <li><strong>Landing Pages:</strong> Create and edit pages with AI assistance using a chat-based builder</li>
              <li><strong>Brand Kit:</strong> Manage company-wide assets like favicon, logo, and images that are automatically injected into published pages</li>
            </Box>
          </Box>
        </InfoAccordion>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={currentTab}
            onChange={(e: any, v: string) => {
              setCurrentTab(v);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            <Tab label="Landing Pages" value="pages" />
            <Tab label="Brand Kit" value="artifacts" />
            <Tab label="Domains" value="domains" />
          </Tabs>
        </Box>
        {currentTab === "pages" && (
          <LandingPagesList
            currentUser={currentUser}
            company={company}
            companyId={companyId}
            employees={employees}
            getToken={getToken}
            eventListener={eventListener}
            currentPlan={currentPlan}
          />
        )}
        {currentTab === "artifacts" && (
          <WebArtifactsPanel
            currentUser={currentUser}
            companyId={companyId}
            getToken={getToken}
            eventListener={eventListener}
          />
        )}
        {currentTab === "domains" && (
          <Box sx={{ mt: 2 }}>
            <TrackingDomainsPanel
              companyId={companyId}
              getToken={getToken}
              title="Custom Domains"
              description="Configure custom domains for your landing pages. Once verified, you can publish landing pages to your own branded URLs (e.g., pages.yourbrand.com)."
              addButtonLabel="Add Domain"
              emptyMessage="No custom domains configured"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LandingPagesManager;
